import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/template-engine/')({
  beforeLoad: () => {
    throw redirect({ to: '/template-engine/templates', replace: true });
  },
});
